// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_52-6";
export var headerCell = "_52-2";
export var loadingStateContent = "_52-8";
export var rowWrapper = "_52-4";
export var stickyAggregationCell = "_52-b";
export var stickyAggregationRow = "_52-7";
export var stickyColumnCell = "_52-a";
export var stickyColumnHeaderCell = "_52-9";
export var table = "_52-1";
export var virtualRowWrapper = "_52-5";
export var virtualTableBodyFiller = "_52-d";
export var virtualTableBodyFillerBottom = "_52-e";
export var virtualTableContainer = "_52-0";
export var virtualTableContainerFill = "_52-c";
export var white = "_52-3";